import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private TRANSLATE_CONFIG: any = {
    English: {
      application_header: "EMAIL SIGNATURE GENERATOR",
      mandatory_fields_note: "Fields containing an * are mandatory",
      welcomeText: "Choose which signature to start:",
      logout: 'Logout',
      email_signature_disclaimer: "This email is confidential and intended only for the use of the above named addressee. If you have received this email in error, please delete it immediately and notify us by email or telephone.",
      form_labels: {
        firstName: "First Name",
        lastName: "Last Name",
        function: "Function",
        division: "Division",
        title: "Title",
        companyName: "Company Name",
        companyURL: "Company URL",
        address: "Address",
        postCode: "Post Code",
        city: "City / State",
        country: "Country",
        phone: "Phone",
        mobile: "Mobile",
        fax: "Fax",
        newEmail: "New Email",
        brand: "Brand",
        banners: "Banners",
        submitToPreview: "Submit to preview",
        selectABanner: "Select a Banner",
        selectABrand: "Select a Brand",
        selectAURL: "Select a URL",
        selectACompany: "Select a Company",
        goBack: "Go Back",
        setMySignature: "Set My Signature"
      },
      set_signature_instructions: `
        <li class="text-start">Go to your gmail <span class="highlight">Settings</span> by clicking on at the top right corner of the
          screen</li>
        <li class="text-start">Click <span class="highlight">See all settings</span></li>
        <li class="text-start">On the <span class="highlight">General</span> tab, scroll down to the <span
        class="highlight">Signature</span> section</li>
        <li class="text-start">Review your Signature under “My Signature” or “Amrize email address”</li>
        <br />
        <li class="text-start">Under your <span class="highlight">Signature defaults</span> (see the screenshot at the right)</li>
        <li class="text-start">Review signature and to ensure that the new Signature are set for both options</li>
        <li class="text-start">Click <span class="highlight">Save changes</span> at the bottom of the screen</li>
        `,
      how_to_set_sign: 'How to make the new created signature to be your default email signature',
      set_sign_success_msg: 'Your signature has been sent to Google, Please refresh your Gmail tab and your browser',
      set_sign_failure_msg: 'Error submitting signature. Please try again.',
      quick_setting_img: 'assets/quick_settings_english.png',
      insert_sign_img: 'assets/insert_signature_english.png',
      banners: [
        { bannerName: 'Amrize tagline', bannerUrl: 'https://storage.googleapis.com/esign-dev-bkt/branding/Amrize_tagline_h_rgb.png' },
        { bannerName: 'Amrize tagline french', bannerUrl: 'https://storage.googleapis.com/esign-dev-bkt/branding/Amrize_tagline_h_French_rgb.png' }
      ],
      desciption_Note: 'Note: Maximum 1000 characters allowed.',
      brandTagline: ' is part of the Amrize family of brands.',
      amrizeStripe: environment.amrizeStripeEnglish
    },
    French: {
      application_header: "GÉNÉRATEUR DE SIGNATURE ÉLECTRONIQUE",
      mandatory_fields_note: "Les champs marqués d'un * sont obligatoires",
      welcomeText: "Pour commencer, choisissez une signature :",
      logout: 'Déconnexion',
      email_signature_disclaimer: "Ce message est confidentiel et est destiné exclusivement à la personne à qui il est adressé. Si ce message vous est parvenu par erreur, veuillez en aviser l'expéditeur immédiatement par courriel et effacer ce message.",
      form_labels: {
        firstName: "Prénom",
        lastName: "Nom de famille",
        function: "Fonction",
        division: "Division",
        title: "Titre",
        companyName: "Nom de la compagnie",
        companyURL: "URL de la compagnie",
        address: "Adresse",
        postCode: "Code postal",
        city: "Ville / État ou province",
        country: "Pays",
        phone: "Téléphone",
        mobile: "Cellulaire",
        fax: "Fax",
        newEmail: "Nouvelle adresse courriel",
        brand: "Marque",
        banners: "Bannières",
        submitToPreview: "Soumettre pour voir un aperçu",
        selectABanner: "Choisissez une bannière",
        selectABrand: "Sélectionnez une marque",
        selectAURL: "Sélectionnez une URL",
        selectACompany: "Sélectionnez une compagnie",
        goBack: "Retour",
        setMySignature: "Définir ma signature"
      },
      set_signature_instructions: `
      <li class="text-start">Allez dans <span class="highlight">Paramètres</span> sur Gmail en cliquant</li>
      <li class="text-start">Cliquez sur <span class="highlight">Voir tous les paramètres</span></li>
      <li class="text-start">Dans l’onglet <span class="highlight">Général</span> rendez-vous à la section <span class="highlight">Signature</span> section</li>
      <li class="text-start">Révisez votre signature</li>
      <br />
      <li class="text-start">Sous <span class="highlight">Valeurs par défaut de la signature</span> (tel qu’indiqué dans la capture d’écran)</li>
      <li class="text-start">Révisez votre signature pour vous assurer que la nouvelle signature est définie pour les deux options</li>
      <li class="text-start">Cliquez sur <span class="highlight">Enregistrer les modifications</span> au bas de l’écran</li>
      `,
      how_to_set_sign: 'COMMENT UTILISER LA NOUVELLE SIGNATURE COMME SIGNATURE COURRIEL PAR DÉFAUT',
      set_sign_success_msg: 'Votre signature a été envoyée à Google. Veuillez actualiser votre onglet Gmail et votre navigateur.',
      set_sign_failure_msg: "Erreur lors de l'envoi de la signature. Veuillez réessayer.",
      quick_setting_img: 'assets/quick_settings_french.png',
      insert_sign_img: 'assets/insert_signature_french.png',
      banners: [
        { bannerName: 'Slogan Amrize', bannerUrl: 'https://storage.googleapis.com/esign-dev-bkt/branding/Amrize_tagline_h_rgb.png' },
        { bannerName: 'Slogan Amrize en français', bannerUrl: 'https://storage.googleapis.com/esign-dev-bkt/branding/Amrize_tagline_h_French_rgb.png' }
      ],
      desciption_Note: 'Remarque : 1000 caractères maximum autorisés.',
      brandTagline: ' fait partie de la famille de marques Amrize.',
      amrizeStripe: environment.amrizeStripeFrench
    }
  }

  get languageConfig() {
    const value = localStorage.getItem('language');
    return this.TRANSLATE_CONFIG?.[value || "English"]
  }

  get language() {
    return localStorage?.getItem('language') || 'English';
  }


}
